import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import LoginAs from "../components/loginAs/loginAs";
import LoginAsLogs from "../components/loginAs/loginAsLogs";

// role-gated so knowing the URL is not enough; the backend checks the same roles
export const loginAsRoutes = [
	<Route key="login-as" path={_adr.Root + _adr.LoginAs.Index} element={<ProtectedRoute role={Roles.Dealer_LoginAs} element={LoginAs} />} />,
	<Route
		key="login-as-logs"
		path={_adr.Root + _adr.LoginAs.Index + _adr.LoginAs.Logs}
		element={<ProtectedRoute role={Roles.Dealer_LoginAs_Audit} element={LoginAsLogs} />}
	/>,
];
